import { initializeApp } from 'firebase/app';
import { globalVars } from './App';
import { getDatabase, ref, get, update, onValue, push, onDisconnect, onChildAdded, goOffline, goOnline, serverTimestamp, runTransaction } from 'firebase/database';
import { firebaseCommands } from './Screens/Game/Game';


const firebaseConfig = {
    apiKey: "AIzaSyC1nvzYqmB7RrarkxHTiwVOa_0VyLVAszc",
    authDomain: "where-is-c203f.firebaseapp.com",
    databaseURL: "https://where-is-c203f.firebaseio.com",
    projectId: "where-is-c203f",
    storageBucket: "where-is-c203f.appspot.com",
    messagingSenderId: "162977474877",
    appId: "1:162977474877:web:0bcef528a95641c180bd54"
};
  
const app = initializeApp(firebaseConfig);
const database = getDatabase(app);

/** Ottiene un valore dal database dato il percorso
 * Intesavincente è implicito
 */
export const getValue = async (path, raw=false) => {
    path = "intesavincente/"+path;
    const snapshot = await get(ref(database, path));
    if(raw) {
        return snapshot;
    }
    return snapshot.val();
}

/** Timestamp del server (millisecondi), da usare come valore di createdAt / lastAction.
 * Il server lo risolve al momento della scrittura, quindi non dipende dall'orologio del dispositivo
 */
export const timestamp = () => serverTimestamp();

/** Scrive più percorsi (relativi a intesavincente) in un'unica operazione.
 * Se la scrittura riguarda una stanza (primo segmento del percorso = codice stanza, con almeno un
 * livello sotto) aggiunge allo stesso update il lastAction della stanza: nessun evento in più.
 * Un valore null rimuove il percorso senza aggiornare il lastAction: se la stanza non esiste più
 * la ricreerebbe vuota (solo lastAction), senza nessuna rimozione automatica.
 * Il percorso della stanza intera non aggiorna il lastAction, perché in quel caso è il valore passato a contenerlo.
 */
const writePaths = (writes) => {
    const updates = {};
    Object.entries(writes).forEach(([path, value]) => {
        const parts = path.split("/").filter(Boolean);
        updates[parts.join("/")] = value;
        if (parts.length > 1 && value !== null) {
            updates[parts[0] + "/lastAction"] = serverTimestamp();
        }
    });
    return update(ref(database, "intesavincente"), updates);
}

/** Imposta un valore nel database dato il percorso
 * Intesavincente è implicito
 */
export const setValue = async (path, value) => {
    return await writePaths({ [path]: value }).then(() => {
        return "ok";
    }).catch((e) => {
        console.error("ERRORE "+ e);
        return e;
    });
}

/** Crea una stanza solo se il codice è libero, in modo atomico (transazione): se nel frattempo
 * qualcun altro ha creato una stanza con lo stesso codice, la transazione si annulla senza scrivere.
 * Restituisce true se la stanza è stata creata, false se il codice è già occupato.
 * Gli errori veri (permessi, rete) arrivano al chiamante come eccezione.
 * Il valore può contenere timestamp(): il server li risolve anche dentro la transazione.
 * Intesavincente è implicito
 */
export const createRoom = async (code, value) => {
    const result = await runTransaction(ref(database, "intesavincente/" + code), (current) => {
        if (current !== null) {
            //codice occupato: nessun valore restituito = transazione annullata
            return;
        }
        return value;
    }, { applyLocally: false });
    return result.committed;
}

/** Appende un valore nel database dato il percorso.
 * Intesavincente è implicito
 */
export const pushValue = async (path, value, shouldRemoveOnDisconnect = false) => {
    const parentRef = ref(database, "intesavincente/" + path);
    try {
        //la chiave si genera qui per poter scrivere elemento e lastAction nella stessa operazione
        const newKey = push(parentRef).key;
        await writePaths({ [path + "/" + newKey]: value });
        if (shouldRemoveOnDisconnect) {
            onDisconnect(parentRef).remove();
        }
        return "ok";
    } catch (e) {
        console.error("ERRORE " + e);
        return e;
    }
};


/** Controlla se il percorso passato esiste nel database.
 * Intesavincente è implicito
 */
export const keyExists = async (path) => {
    path = "intesavincente/"+path;
    const snapshot = await get(ref(database, path));
    
    return snapshot.exists();
};

/** In un percorso con elementi pushed restituisce la key che contiene
 * la coppia key-value passata
 * Intesavincente è implicito
 */
export const getKey = async (path, key, value) => {
    path = "intesavincente/"+path;
    const snapshot = await get(ref(database, path));
    let realKey = null;

    snapshot.forEach((e) => {
        let val = e.val();
        //console.log(val[key]);
        if(val[key] == value) {
            //esiste una chiave nel percorso con il valore indicato
            //console.log(e.key);
            realKey = e.key;
            return;
        }
    });

    return realKey;
}

/** Aggiunge un listener al percorso passato.
 * Restituisce un callback (parametro) e il listener stesso per disconnetterlo
 * Intesavincente + globalVars.code/ è implicito
 */
export const addPathListener = async (path, callback) => {
    path = "intesavincente/"+ globalVars.code+ "/"+ path;

    const listener = onValue(ref(database, path), (snapshot) => {
        callback(snapshot.val());
    });
    //usato per il detatch
    return listener;
}

/** Aggiunge un onDisconnectListener al percorso.
 * Se il percorso non viene specificato, controlla se il client è un display o un bottone
 * e aggiunge il listener al percorso relativo di default.
 * Intesavincente è implicito
 */
export const addPresence = async (path=null) => {
    if(path==null) {
        if(globalVars.type == "b") {
            path = "intesavincente/"+ globalVars.code+ "/button";
        }
        if(globalVars.type == "d") {
            path = "intesavincente/"+ globalVars.code+ "/display";
        }
    } else {
        path = "intesavincente/" + path;
    }
    
    onDisconnect(ref(database, path)).remove(ref(database, path));
}

/** Annulla l'onDisconnect impostato da addPresence sullo stesso percorso
 * (es. il display torna alla scelta del dispositivo e rimuove la stanza da sé).
 * Intesavincente è implicito
 */
export const cancelPresence = async (path) => {
    path = "intesavincente/" + path;
    return await onDisconnect(ref(database, path)).cancel().then(() => {
        return "ok";
    }).catch((e) => {
        console.error("ERRORE "+ e);
        return e;
    });
}


/** Avvisa il chiamante quando il client corrente si disconnette chiamando
 * la funzione callback
 */
export const onClientDisconnected = async (callback) => {
    const connectedRef = ref(database, '.info/connected');
    
    // Aggiungi un listener per rilevare la disconnessione del client
    return onValue(connectedRef, (snapshot) => {
      const isConnected = snapshot.val();
      
      if (isConnected === false) {
        //console.log("client disconnected");
        callback();
      }
    });
}

/** Avvisa il chiamante quando il client opposto si disconnette chiamando
 * la funzione callback
 */
export const onPeerDisconnected = async (callback) => {
    let path;
    if(globalVars.type == "b") {
        path = "intesavincente/"+ globalVars.code+ "/display";
    }
    if(globalVars.type == "d") {
        path = "intesavincente/"+ globalVars.code+ "/button";
    }

    return onValue(ref(database, path), (snapshot) => {
        if (!snapshot.exists()) {
            callback();
        }
    });
}

/** RIimuove un percorso dal database
 * Intesavincente è implicito
 */
export const removePath = async (path) => {
    return await writePaths({ [path]: null }).then(() => {
        return "ok";
    }).catch((e) => {
        console.error("ERRORE "+ e);
        return e;
    });
}

//Intervallo minimo (ms) tra l'esecuzione di due comandi. Con una rete lenta i comandi si accumulano e arrivano quasi
//insieme: React raggruppa gli aggiornamenti e salta i passaggi intermedi (la parola non viene mai generata, ma la risposta
//assegna comunque il punto). Con questo intervallo ogni comando ha il tempo di mostrare il suo stato prima del successivo.
//Un comando che arriva a coda vuota e dopo l'intervallo parte subito, senza ritardo.
const COMMAND_GAP = 60;

/** Aggiunge un listener alla lista dei comandi ed esegue il comando quando lo riceve.
 * I comandi vengono eseguiti uno alla volta, nell'ordine di arrivo, distanziati di almeno COMMAND_GAP.
 * Restituisce la funzione che rimuove il listener e svuota la coda.
 */
export const addNewCommandsListener = async () => {
    const path = "intesavincente/"+globalVars.code+"/commands";
    const dbRef = ref(database, path);

    const queue = [];
    let running = false;
    let stopped = false;
    let lastRun = -COMMAND_GAP;     //il primo comando non deve aspettare

    const execute = (data) => {
        //scorre tra tutti i comandi e confronta il nome
        Object.entries(firebaseCommands).forEach(([key, c]) => {
            if(c.name == data.commandName) {
                //console.log("comando trovato");
                if(data.commandName == "showButton" && data.status) {
                    c.call(firebaseCommands.reciver, data.status);
                    return;
                }
                if(data.commandName == "showResults" && data.wait) {
                    c.call(firebaseCommands.reciver, true, data.wait);
                    return;
                }
                if(data.commandName == "startVideo" && typeof data.isLast === "boolean") {
                    c.call(firebaseCommands.reciver, data.isLast);
                    return;
                }
                c.call(firebaseCommands.reciver);
                return;
            }
        })
    }

    const drain = async () => {
        if(running) {
            return;
        }
        running = true;
        while(queue.length && !stopped) {
            const wait = COMMAND_GAP - (performance.now() - lastRun);
            if(wait > 0) {
                await new Promise((resolve) => setTimeout(resolve, wait));
            }
            if(stopped) {
                break;
            }
            lastRun = performance.now();
            try {
                execute(queue.shift());
            } catch (e) {
                //un comando che fallisce non deve bloccare quelli dopo
                console.error("ERRORE comando: " + e);
            }
        }
        running = false;
    }

    // Listener for child added
    const unsubscribe = onChildAdded(dbRef, (snapshot) => {
        const data = snapshot.val();
        //console.log(data);
        //console.log("NOT FIRST "+ data);
        if((data.sentBy == globalVars.type && data.executeSelf == true) || data.sentBy != globalVars.type) {
            queue.push(data);
            drain();
        }
    });

    // Return the listener so it can be removed later
    return () => {
        stopped = true;
        queue.length = 0;
        unsubscribe();
    };
}


export const disconnect = () => {
    goOffline(database);
}

export const connect = () => {
    goOnline(database);
}

export default app;
